import { useBankContext } from "../util/BankContext";
export default function Favicon() {
    const bank = useBankContext();
    const favicon =  `/img/${bank.staticFilePathPrefix}/favicon.ico`
    document.getElementById('portal_favicon').href = favicon;
    return false;
}
